import React from "react";
import PageHeader from "../components/PageHeader";
import { Link } from "react-router-dom";

export default function AnnualReport() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Documents", link: "/documents" },
    { label: "Annual Report", active: true },
  ];

  const documents = [
    { title: "Annual Report 2024-2025", link: "/assests/img/bscpcrRuleandActs/Annual_Report_2024_2025.pdf" },
   
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader title="Annual Report (BSCPCR)" breadcrumbs={breadcrumbs} />

      {/* Timeline Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-primary fw-bold mb-5 text-center">Annual Report</h2>

         <div className="row g-4">
            {documents.map((doc, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="h-100 bg-white p-4 rounded-4 shadow-sm border-start border-4 border-primary">
                  <h6 className="fw-bold text-primary mb-3">
                    {doc.title}
                  </h6>
                  <a
                    href={doc.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-primary rounded-pill w-100"
                  >
                    View / Download
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
